// extracted by mini-css-extract-plugin
export default {"container":"SliderItem_container__t9r-m","slideCardColor":"SliderItem_slideCardColor__CgCeO","title":"SliderItem_title__1eI1n","promotionText":"SliderItem_promotionText__Y5YTC"};